<template>
  <div>
    <DetailIndex :evgExpenseCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-evgExpense',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
